<script lang="ts">
    import { writable } from 'svelte/store'
    import CustomerServiceForm from '../customer-service/customer-service-form.svelte'
    import FormV2FormEditor from '../customer-service-v2/forms/form-v2-form-editor.svelte'
    import Popover from './popover.svelte'
    import { createEventDispatcher } from 'svelte'
    import type { PopoverWindowInterface } from './popover-window.interface'
    import PosForm from '../pos/pos-form.svelte'
    import AppointmentForm from '../agenda/appointment-form.svelte'
    import ReportExportLinkPopover from '../reports-v2/_shared/report-export-link-popover.svelte'
    const dispatch = createEventDispatcher()

    export const globalPopoverWindow = writable(null)

    window.popover = (params: PopoverWindowInterface) => {
        globalPopoverWindow.update((_) => params)
    }

    let localParams: PopoverWindowInterface = null
    globalPopoverWindow.subscribe((value: PopoverWindowInterface) => {
        localParams = value
    })

    function goClose() {
        dispatch('close', JSON.parse(JSON.stringify(localParams)))
        globalPopoverWindow.update((_) => null)
    }
    function goCancel() {
        dispatch('cancel', JSON.parse(JSON.stringify(localParams)))
        globalPopoverWindow.update((_) => null)
    }

    async function goChange(ev) {
        dispatch('change', JSON.parse(JSON.stringify(localParams)))
        if (localParams.callback) {
            await localParams.callback(ev.detail || undefined)
        }
        globalPopoverWindow.update((_) => null)
    }
</script>

{#if localParams}
    {#if localParams.act === 'customer-service'}
        <Popover
            title="Atendimento"
            width="1300px"
            height="400px"
            on:close={() => {
                goClose() // realizar o changed, pois pode ser que o form foi alterado como rascunho
            }}
        >
            <CustomerServiceForm
                personId={localParams.data.personId}
                formDataId={localParams.data.formDataId}
                invoiceId={localParams.data.invoiceId}
                billId={localParams.data.billId}
                view={localParams.data.view}
                types={localParams.data.types}
                on:cancel={goCancel}
                on:change={goChange}
            />
        </Popover>
    {/if}

    {#if localParams.act === 'customer-service-v2'}
        <Popover
            padding="16px"
            title="Atendimento"
            width="1300px"
            height="400px"
            on:close={() => {
                goClose() // realizar o changed, pois pode ser que o form foi alterado como rascunho
            }}
        >
            <FormV2FormEditor
                formV2FormId={localParams.data.formV2FormId}
                personId={localParams.data.personId}
                invoiceId={localParams.data.invoiceId}
                billId={localParams.data.billId}
                view={localParams.data.view}
                types={localParams.data.types}
                on:cancel={goCancel}
                on:change={goChange}
            />
        </Popover>
    {/if}

    {#if localParams.act === 'pos-form'}
        <Popover
            title="Venda"
            width="1300px"
            height="90vh"
            on:close={() => {
                goClose()
            }}
        >
            <PosForm invoiceId={localParams.data.invoiceId} on:change={goChange} on:cancel={goCancel} />
        </Popover>
    {/if}

    {#if localParams.act === 'appointment-form'}
        <Popover
            title="Agendamento"
            width="1080px"
            height="80vh"
            on:close={() => {
                goClose()
            }}
        >
            <AppointmentForm on:change={goChange} on:close={goClose} appointmentId={localParams.data.appointmentId} />
        </Popover>
    {/if}

    {#if localParams.act === 'report-export-link'}
        <Popover title="Link" width="790px" padding="16px" on:close={goClose}>
            <ReportExportLinkPopover reportId={localParams.data.reportId} params={localParams.data.params} />
        </Popover>
    {/if}
{/if}
